import { GenIcon } from '../helpers/IconBase.es.js';

const InforOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "mask",
        attr: { id: "icon-jyhw769hz", fill: "white" },
        child: [
          {
            tag: "path",
            attr: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12 17.2954C11.5858 17.2954 11.25 16.9596 11.25 16.5454V11.0909C11.25 10.6767 11.5858 10.3409 12 10.3409C12.4142 10.3409 12.75 10.6767 12.75 11.0909V16.5454C12.75 16.9596 12.4142 17.2954 12 17.2954ZM11 7.45459C11 6.90231 11.4477 6.45459 12 6.45459C12.5523 6.45459 13 6.90231 13 7.45459C13 8.00687 12.5523 8.45459 12 8.45459C11.4477 8.45459 11 8.00687 11 7.45459Z"
            }
          }
        ]
      },
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12 17.2954C11.5858 17.2954 11.25 16.9596 11.25 16.5454V11.0909C11.25 10.6767 11.5858 10.3409 12 10.3409C12.4142 10.3409 12.75 10.6767 12.75 11.0909V16.5454C12.75 16.9596 12.4142 17.2954 12 17.2954ZM11 7.45459C11 6.90231 11.4477 6.45459 12 6.45459C12.5523 6.45459 13 6.90231 13 7.45459C13 8.00687 12.5523 8.45459 12 8.45459C11.4477 8.45459 11 8.00687 11 7.45459Z",
          fill: "#82869E"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M19.5 12C19.5 16.1421 16.1421 19.5 12 19.5V21.5C17.2467 21.5 21.5 17.2467 21.5 12H19.5ZM12 4.5C16.1421 4.5 19.5 7.85786 19.5 12H21.5C21.5 6.75329 17.2467 2.5 12 2.5V4.5ZM4.5 12C4.5 7.85786 7.85786 4.5 12 4.5V2.5C6.75329 2.5 2.5 6.75329 2.5 12H4.5ZM12 19.5C7.85786 19.5 4.5 16.1421 4.5 12H2.5C2.5 17.2467 6.75329 21.5 12 21.5V19.5ZM12 23C18.0751 23 23 18.0751 23 12H21C21 16.9706 16.9706 21 12 21V23ZM1 12C1 18.0751 5.92487 23 12 23V21C7.02944 21 3 16.9706 3 12H1ZM12 1C5.92487 1 1 5.92487 1 12H3C3 7.02944 7.02944 3 12 3V1ZM23 12C23 5.92487 18.0751 1 12 1V3C16.9706 3 21 7.02944 21 12H23ZM10.25 16.5454C10.25 17.5119 11.0335 18.2954 12 18.2954V16.2954C12.1381 16.2954 12.25 16.4073 12.25 16.5454H10.25ZM10.25 11.0909V16.5454H12.25V11.0909H10.25ZM12 9.34086C11.0335 9.34086 10.25 10.1244 10.25 11.0909H12.25C12.25 11.2289 12.1381 11.3409 12 11.3409V9.34086ZM13.75 11.0909C13.75 10.1244 12.9665 9.34086 12 9.34086V11.3409C11.8619 11.3409 11.75 11.2289 11.75 11.0909H13.75ZM13.75 16.5454V11.0909H11.75V16.5454H13.75ZM12 18.2954C12.9665 18.2954 13.75 17.5119 13.75 16.5454H11.75C11.75 16.4073 11.8619 16.2954 12 16.2954V18.2954ZM12 5.45459C10.8954 5.45459 10 6.35002 10 7.45459H12V5.45459ZM14 7.45459C14 6.35002 13.1046 5.45459 12 5.45459V7.45459H14ZM12 9.45459C13.1046 9.45459 14 8.55916 14 7.45459H12V9.45459ZM10 7.45459C10 8.55916 10.8954 9.45459 12 9.45459V7.45459H10Z",
          fill: "#82869E",
          mask: "url(#icon-jyhw769hz)"
        }
      }
    ]
  })(props);
};

export { InforOutlined };
